import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { SITE_CONFIG } from "@/constants";
import { useLanguage } from "@/contexts/language-context";

export function Footer() {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <img src="/纯logo无文字.png" alt="Logo" className="h-10 w-auto" />
              <span className="font-bold text-xl text-white">
                {t("header.siteName")}
              </span>
            </div>
            <p className="text-sm mb-4 max-w-md">{SITE_CONFIG.description}</p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="hover:text-white transition-colors"
                aria-label="WeChat"
              >
                WeChat
              </a>
              <a
                href="#"
                className="hover:text-white transition-colors"
                aria-label="Weibo"
              >
                Weibo
              </a>
              <a
                href="#"
                className="hover:text-white transition-colors"
                aria-label="TikTok"
              >
                TikTok
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">{t("footer.quickLinks")}</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm hover:text-white transition-colors"
                >
                  {t("nav.home")}
                </Link>
              </li>
              <li>
                <Link
                  to="/products"
                  className="text-sm hover:text-white transition-colors"
                >
                  {t("nav.vehicles")}
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-sm hover:text-white transition-colors"
                >
                  {t("nav.contact")}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">{t("footer.contactUs")}</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-sm">
                <Phone size={16} className="mt-1 flex-shrink-0" />
                <span>{SITE_CONFIG.links.phone}</span>
              </li>
              <li className="flex items-start space-x-2 text-sm">
                <Mail size={16} className="mt-1 flex-shrink-0" />
                <span>{SITE_CONFIG.links.email}</span>
              </li>
              <li className="flex items-start space-x-2 text-sm">
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                <span>{t("footer.address")}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-sm">
          <p>
            © {currentYear} {SITE_CONFIG.name}. {t("footer.copyright")}
          </p>
        </div>
      </div>
    </footer>
  );
}
